<template>
  <div>
    <button
      type="button"
      class="btn btn-link p-0 d-inline-flex align-items-center gap-2 text-decoration-none"
      :aria-expanded="guideOpen"
      :aria-controls="guideBodyId"
      @click="guideOpen = !guideOpen"
    >
      <FontAwesomeIcon icon="fa-regular fa-circle-info" />
      <span class="fw-semibold">{{
        $t("forwards.mandates.eligibility.guide.title")
      }}</span>
      <FontAwesomeIcon :icon="guideOpen ? 'chevron-down' : 'chevron-right'" />
    </button>
    <div v-show="guideOpen" :id="guideBodyId" class="mt-2">
      <p class="mb-1">{{ $t("forwards.mandates.eligibility.guide.intro") }}</p>
      <ul class="mb-2">
        <li>{{ $t("forwards.mandates.eligibility.guide.unsupported") }}</li>
        <li>{{ $t("forwards.mandates.eligibility.guide.biomass") }}</li>
        <li>{{ $t("forwards.mandates.eligibility.guide.issuance") }}</li>
      </ul>
      <p class="mb-0" data-testid="eligibility-guide-several-mandates">
        {{
          $t("forwards.mandates.eligibility.guide.several_mandates", {
            option: $t("forwards.mandates.devices.use_allowlist"),
            section: $t("forwards.mandates.devices.title"),
          })
        }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";

/**
 * How to group a mandate's devices so that none keeps the mandate out of a deal, collapsible below the
 * mandate editor's deal eligibility table, whose values it explains how to improve. It names the device
 * section's own labels, so the hint follows them when they are renamed.
 */
const guideBodyId = useId();

// Collapsed on every mount, as the forward sales guide (user decision, 2026-10-13).
const guideOpen = ref(false);
</script>
